import { render, staticRenderFns } from "./PowerBIReportsPage.vue?vue&type=template&id=20890f24&"
import script from "./PowerBIReportsPage.vue?vue&type=script&lang=js&"
export * from "./PowerBIReportsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports